import $ from 'jquery/src/jquery';

export default () => {
    const nodeSelectors = {
        container: '[js-site-header="container"]',
    }

    function init() {
        initHeader()
    }

    function initHeader() {
        $('.menu-holder .menu-item-has-children').hover(
            function(e) {
                $(this).find('.sub-menu').stop().slideDown('fast');
                $(this).find('.sub-menu').addClass('opened')
            }, function() {
                $('.sub-menu').stop().slideUp('fast');
                $(this).find('.sub-menu').removeClass('opened')
                // $(this).find('.sub-menu li').css('opacity', 0)
            }
        );

        $('.mobile-menu-opener').on('click', function(){
            $(this).find('#hamburger').toggleClass('active')
            $('#site-mobile-nav').slideToggle('fast')
        })

        $( ".mobile-nav-content li" ).each(function( index ) {
            if($(this).hasClass('menu-item-has-children')){
                // $(this).append('<div class="sub-menu-opener">+<div>')
                $(this).find('a').first().wrap( "<div class='link-wrapper'></div>" )
                $(this).find('.link-wrapper').append('<div class="sub-menu-opener">+<div>')
            }
        });
        
        $(document).on('click', '#site-mobile-nav .link-wrapper .sub-menu-opener', function(){ 
            $(this).parent().parent().find('.sub-menu').slideToggle('fast');
            $(this).parent().parent().find('.sub-menu').toggleClass('opened')
        }); 

    }

    return Object.freeze({
        init,
    })
}